module.exports = __webpack_public_path__ + "img/red.bb5f13ce.svg";